(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["axolt-home-clinics"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('axh-tabs')) {
    customElements.define('axh-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => {
            let next = null;
            if (e.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
            if (e.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
            if (e.key === 'Home') next = 0;
            if (e.key === 'End') next = this.tabs.length - 1;
            if (next !== null) { e.preventDefault(); this.select(next); this.tabs[next].focus(); }
          });
        });
      }
      select(index) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
    });
  }
  document.addEventListener('shopify:block:select', (e) => {
    const panel = e.target.closest && e.target.closest('.axh-clinics__panel');
    const root = panel && panel.closest('axh-tabs');
    if (!root || !root.tabs) return;
    const i = root.tabs.findIndex((t) => t.getAttribute('aria-controls') === panel.id);
    if (i > -1) root.select(i);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axolt-home-problem"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bind(root) {
      root.querySelectorAll('[data-axh-exclusive]').forEach(function (acc) {
        if (acc.dataset.axhBound) return;
        acc.dataset.axhBound = '1';
        acc.addEventListener('toggle', function (event) {
          var opened = event.target;
          if (!opened.open || opened.parentElement !== acc) return;
          acc.querySelectorAll(':scope > details[open]').forEach(function (other) {
            if (other !== opened) other.open = false;
          });
        }, true);
      });
    }
    bind(document);
    document.addEventListener('shopify:section:load', function (event) { bind(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axolt-home-products"] && !Shopify.designMode) return;
  try {
    
  /* Card hover: while the pointer is on a card, the x marker keeps going round
     the circle (Axolt) or keeps drawing the arc from the bottom dot to the top
     (Axolt Lift), slowly. When the pointer leaves, the circle stops where it is
     (and carries on from there next time); the arc settles back to its full,
     resting state. Mouse devices only; skipped for reduced motion. */
  (function () {
    if (!window.matchMedia('(hover: hover)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var LAP_MS = 9000;      // one slow turn round the circle
    var DRAW_MS = 2600;     // arc, bottom to top
    var HOLD_MS = 900;      // pause at the top before the next draw
    var SETTLE_MS = 450;    // arc back to rest after the pointer leaves
    var REST_ANGLE = -Math.PI / 6;
    var easeInOut = function (t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };

    function setArc(svg, e) {
      var line = svg._axhLine, len = svg._axhLen;
      var pt = line.getPointAtLength(len * e);
      line.style.strokeDasharray = len;
      line.style.strokeDashoffset = len * (1 - e);
      svg._axhMarker.setAttribute('transform', 'translate(' + pt.x + ' ' + pt.y + ') scale(' + (0.48 + 0.52 * e) + ')');
      svg._axhProgress = e;
    }
    function setCircle(svg, a) {
      svg._axhAngle = a;
      svg._axhMarker.setAttribute('transform', 'translate(' + (105 + 104 * Math.cos(a)) + ' ' + (105 + 104 * Math.sin(a)) + ')');
    }

    function start(svg) {
      svg._axhHover = true;
      if (svg._axhRaf) return;
      var arc = svg.dataset.axhDeco === 'arc';
      var last = null, phase = 0;
      if (arc) { phase = 0; } else if (svg._axhAngle === undefined) { svg._axhAngle = REST_ANGLE; }

      function frame(now) {
        var dt = last === null ? 0 : now - last;
        last = now;
        if (arc) {
          if (svg._axhHover) {
            phase = (phase + dt) % (DRAW_MS + HOLD_MS);
            setArc(svg, phase < DRAW_MS ? easeInOut(phase / DRAW_MS) : 1);
          } else {
            var e = Math.min(1, svg._axhProgress + dt / SETTLE_MS);
            setArc(svg, e);
            if (e >= 1) {
              svg._axhLine.style.strokeDasharray = '';
              svg._axhLine.style.strokeDashoffset = '';
              svg._axhMarker.setAttribute('transform', 'translate(264 34)');
              svg._axhRaf = null;
              return;
            }
          }
        } else {
          if (!svg._axhHover) { svg._axhRaf = null; return; }
          setCircle(svg, (svg._axhAngle + dt / LAP_MS * Math.PI * 2) % (Math.PI * 2));
        }
        svg._axhRaf = requestAnimationFrame(frame);
      }
      svg._axhRaf = requestAnimationFrame(frame);
    }

    function bind(root) {
      root.querySelectorAll('.axh-pcard').forEach(function (card) {
        if (card.dataset.axhDecoBound) return;
        var svg = card.querySelector('[data-axh-deco]');
        var marker = svg && svg.querySelector('.axh-deco__marker');
        if (!marker) return;
        card.dataset.axhDecoBound = '1';
        svg._axhMarker = marker;
        svg._axhLine = svg.querySelector('.axh-deco__line');
        if (svg._axhLine) svg._axhLen = svg._axhLine.getTotalLength();
        card.addEventListener('mouseenter', function () { start(svg); });
        card.addEventListener('mouseleave', function () { svg._axhHover = false; });
      });
    }
    bind(document);
    document.addEventListener('shopify:section:load', function (event) { bind(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axolt-home-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setup(marquee) {
      if (marquee.dataset.axhBound) return;
      marquee.dataset.axhBound = '1';
      var lane = marquee.querySelector('.axh-reviews__lane');
      var group = lane && lane.querySelector('.axh-reviews__group');
      if (!group) return;

      if (!reduce.matches && !window.Shopify.designMode) {
        var clone = group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        clone.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
        clone.querySelectorAll('a, button, [tabindex]').forEach(function (n) { n.setAttribute('tabindex', '-1'); });
        clone.querySelectorAll('[data-shopify-editor-block]').forEach(function (n) { n.removeAttribute('data-shopify-editor-block'); });
        lane.appendChild(clone);
        var speed = parseFloat(marquee.dataset.speed) || 30;
        var update = function () {
          marquee.style.setProperty('--axh-marquee-duration', (group.getBoundingClientRect().width / speed) + 's');
        };
        update();
        window.addEventListener('resize', update);
        marquee.classList.add('is-moving');
      }

    }

    /* Video cards: tap to play with sound; the row pauses while a video plays. */
    function videos(marquee) {
      if (marquee.dataset.axhVideos) return;
      marquee.dataset.axhVideos = '1';
      var anyPlaying = function () {
        return [].some.call(marquee.querySelectorAll('video'), function (v) { return !v.paused && !v.ended; });
      };
      marquee.addEventListener('click', function (event) {
        var card = event.target.closest('[data-axh-vcard]');
        var video = card && card.querySelector('video');
        if (!video || !video.paused) return;
        marquee.querySelectorAll('video').forEach(function (v) { if (v !== video) v.pause(); });
        video.controls = true;
        var p = video.play(); if (p && p.catch) p.catch(function () {});
      });
      marquee.addEventListener('play', function () { marquee.classList.add('is-playing'); }, true);
      ['pause', 'ended'].forEach(function (type) {
        marquee.addEventListener(type, function (event) {
          if (type === 'ended') event.target.controls = false;
          if (!anyPlaying()) marquee.classList.remove('is-playing');
        }, true);
      });
    }

    function bind(root) { root.querySelectorAll('[data-axh-marquee]').forEach(function (m) { setup(m); videos(m); }); }
    bind(document);
    document.addEventListener('shopify:section:load', function (event) { bind(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-copy"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
  constructor() {
  super();
  }

  connectedCallback() {
  this.header = document.querySelector('.section-header');
  this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' ||
  this.getAttribute('data-sticky-type') === 'reduce-logo-size';
  this.headerBounds = {};

  this.setHeaderHeight();

  window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

  if (this.headerIsAlwaysSticky) {
  this.header.classList.add('shopify-section-header-sticky');
  };

  this.currentScrollTop = 0;
  this.preventReveal = false;
  this.predictiveSearch = this.querySelector('predictive-search');

  this.onScrollHandler = this.onScroll.bind(this);
  this.hideHeaderOnScrollUp = () => this.preventReveal = true;

  this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  window.addEventListener('scroll', this.onScrollHandler, false);

  this.createObserver();
  }

  setHeaderHeight() {
  document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
  this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
  let observer = new IntersectionObserver((entries, observer) => {
  this.headerBounds = entries[0].intersectionRect;
  observer.disconnect();
  });

  observer.observe(this.header);
  }

  onScroll() {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

  if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
  this.header.classList.add('scrolled-past-header');
  if (this.preventHide) return;
  requestAnimationFrame(this.hide.bind(this));
  } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
  this.header.classList.add('scrolled-past-header');
  if (!this.preventReveal) {
  requestAnimationFrame(this.reveal.bind(this));
  } else {
  window.clearTimeout(this.isScrolling);

  this.isScrolling = setTimeout(() => {
  this.preventReveal = false;
  }, 66);

  requestAnimationFrame(this.hide.bind(this));
  }
  } else if (scrollTop <= this.headerBounds.top) {
  this.header.classList.remove('scrolled-past-header');
  requestAnimationFrame(this.reset.bind(this));
  }

  this.currentScrollTop = scrollTop;
  }

  hide() {
  if (this.headerIsAlwaysSticky) return;
  this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  this.closeMenuDisclosure();
  this.closeSearchModal();
  }

  reveal() {
  if (this.headerIsAlwaysSticky) return;
  this.header.classList.add('shopify-section-header-sticky', 'animate');
  this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
  if (this.headerIsAlwaysSticky) return;
  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
  this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
  this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
  this.searchModal = this.searchModal || this.header.querySelector('details-modal');
  this.searchModal.close(false);
  }
  }

  customElements.define('sticky-header', StickyHeader);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
  constructor() {
  super();
  }

  connectedCallback() {
  this.header = document.querySelector('.section-header');
  this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' ||
  this.getAttribute('data-sticky-type') === 'reduce-logo-size';
  this.headerBounds = {};

  this.setHeaderHeight();

  window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

  if (this.headerIsAlwaysSticky) {
  this.header.classList.add('shopify-section-header-sticky');
  };

  this.currentScrollTop = 0;
  this.preventReveal = false;
  this.predictiveSearch = this.querySelector('predictive-search');

  this.onScrollHandler = this.onScroll.bind(this);
  this.hideHeaderOnScrollUp = () => this.preventReveal = true;

  this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  window.addEventListener('scroll', this.onScrollHandler, false);

  this.createObserver();
  }

  setHeaderHeight() {
  document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
  this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
  let observer = new IntersectionObserver((entries, observer) => {
  this.headerBounds = entries[0].intersectionRect;
  observer.disconnect();
  });

  observer.observe(this.header);
  }

  onScroll() {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

  if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
  this.header.classList.add('scrolled-past-header');
  if (this.preventHide) return;
  requestAnimationFrame(this.hide.bind(this));
  } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
  this.header.classList.add('scrolled-past-header');
  if (!this.preventReveal) {
  requestAnimationFrame(this.reveal.bind(this));
  } else {
  window.clearTimeout(this.isScrolling);

  this.isScrolling = setTimeout(() => {
  this.preventReveal = false;
  }, 66);

  requestAnimationFrame(this.hide.bind(this));
  }
  } else if (scrollTop <= this.headerBounds.top) {
  this.header.classList.remove('scrolled-past-header');
  requestAnimationFrame(this.reset.bind(this));
  }

  this.currentScrollTop = scrollTop;
  }

  hide() {
  if (this.headerIsAlwaysSticky) return;
  this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  this.closeMenuDisclosure();
  this.closeSearchModal();
  }

  reveal() {
  if (this.headerIsAlwaysSticky) return;
  this.header.classList.add('shopify-section-header-sticky', 'animate');
  this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
  if (this.headerIsAlwaysSticky) return;
  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
  this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
  this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
  this.searchModal = this.searchModal || this.header.querySelector('details-modal');
  this.searchModal.close(false);
  }
  }

  customElements.define('sticky-header', StickyHeader);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["us-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
  constructor() {
  super();
  }

  connectedCallback() {
  this.header = document.querySelector('.section-header');
  this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' ||
  this.getAttribute('data-sticky-type') === 'reduce-logo-size';
  this.headerBounds = {};

  this.setHeaderHeight();

  window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

  if (this.headerIsAlwaysSticky) {
  this.header.classList.add('shopify-section-header-sticky');
  };

  this.currentScrollTop = 0;
  this.preventReveal = false;
  this.predictiveSearch = this.querySelector('predictive-search');

  this.onScrollHandler = this.onScroll.bind(this);
  this.hideHeaderOnScrollUp = () => this.preventReveal = true;

  this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  window.addEventListener('scroll', this.onScrollHandler, false);

  this.createObserver();
  }

  setHeaderHeight() {
  document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
  this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
  let observer = new IntersectionObserver((entries, observer) => {
  this.headerBounds = entries[0].intersectionRect;
  observer.disconnect();
  });

  observer.observe(this.header);
  }

  onScroll() {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

  if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
  this.header.classList.add('scrolled-past-header');
  if (this.preventHide) return;
  requestAnimationFrame(this.hide.bind(this));
  } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
  this.header.classList.add('scrolled-past-header');
  if (!this.preventReveal) {
  requestAnimationFrame(this.reveal.bind(this));
  } else {
  window.clearTimeout(this.isScrolling);

  this.isScrolling = setTimeout(() => {
  this.preventReveal = false;
  }, 66);

  requestAnimationFrame(this.hide.bind(this));
  }
  } else if (scrollTop <= this.headerBounds.top) {
  this.header.classList.remove('scrolled-past-header');
  requestAnimationFrame(this.reset.bind(this));
  }

  this.currentScrollTop = scrollTop;
  }

  hide() {
  if (this.headerIsAlwaysSticky) return;
  this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  this.closeMenuDisclosure();
  this.closeSearchModal();
  }

  reveal() {
  if (this.headerIsAlwaysSticky) return;
  this.header.classList.add('shopify-section-header-sticky', 'animate');
  this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
  if (this.headerIsAlwaysSticky) return;
  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
  this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
  this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
  this.searchModal = this.searchModal || this.header.querySelector('details-modal');
  this.searchModal.close(false);
  }
  }

  customElements.define('sticky-header', StickyHeader);
  
  } catch(e) { console.error(e); }
})();
})();
